/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function () {
  $(".overall-rating_filter_line").click(function () {
    var currentData = $(this).attr("data"); // values: 1,2,3,4,5,all


    // Step 1: Trigger "Clear Filters"
    setTimeout(function(){
      $(".c-filters__dropdown__clearButton [role='button']").trigger("click");
    },200);
    $('#product-review-panel').css('opacity', '0');
  
    // Step 2: Trigger Breakdown click
    setTimeout(function(){
      if (currentData !== "all") {
        // Find Breakdown group → star with matching aria-label like "4 star rating"
        const selector = `.R-DropUpDownMenu__item .R-RatingStars [title='${currentData} Stars']`;
        const $target = $(selector).closest(".R-DropUpDownMenu__item");
    
        if ($target.length) {
          $target.trigger("click");
          $('#product-review-panel').css('opacity', '1');
        }
      }
      $('#product-review-panel').css('opacity', '1');
    },500);
    
  });

  $(document).on("click",".reviews-pdp_mobile_filter_trigger",function() {
      $('.filter__rsp_popup-outer').css('display', 'flex');
      if (typeof updateApplyBtnCount === 'function') updateApplyBtnCount();
  });


  $('.pdp_rating_tooltip-stars-line').click(function(){
    $('.pdp_rating-tooltip').hide();
    var currentData = $(this).attr('data');
    $('html, body').animate({
        scrollTop: $(".reviews-pdp").offset().top
    }, 500);

    $(".overall-rating_filter_line[data='" + currentData + "']").trigger("click");
  });


  $(document).on('click', '.filter__rsp-tab-sort-line', function(){
    $('.filter__rsp-tab-sort-line').removeClass('active');
    $(this).addClass('active');
    var sortVal = $(this).attr('data');
    if (sortVal) {
      $('.pdp_sr-val[data="' + sortVal + '"]').trigger('click');
    }
  });
  
  $('.filter__rsp-apply-btn').click(function(){
    $('.filter__rsp_popup-outer').hide();
  });
  
  $('.filter__rsp_popup-close').click(function(){
    $('.filter__rsp_popup-outer').hide();
  });
  
  $(".star_filter-line-top").click(function () {
    var data = $(this).attr("data");
    var $target = $(".overall-rating_filter_line[data='" + data + "']");
    if ($target.hasClass("disabled") || $target.hasClass("isDisabled")) return;
    $target.trigger("click");
  });
  
  $('.filter__rsp_popup-outer').click(function(e){
    const $popupOuter = $('.filter__rsp_popup-outer');
    const $popupInner = $('.filter__rsp_popup-inner');
    if ($popupOuter.is(':visible') && !$popupInner.is(e.target) && $popupInner.has(e.target).length === 0) {
      $popupOuter.hide();
    }
  });

  

  $('.filter__rsp-tab-thumb').click(function(){
    $(this).toggleClass('active');
    $(this).closest('.filter__rsp-tab').find('.filter__rsp-tab-content').slideToggle();
  });

  function closeReviewsPopup() {
    $('.desk_pdp-reviews-fill-popup').hide();
    $('body').removeClass('popup-open');
    window.unlockScroll();
  }

  $(document).on('click', '.reviews-summary-fill-form_trigger', function (e) {
    e.preventDefault();
    $(
      ".real-reviews .ElementsWidget-prefix .ElementsWidget .ElementsWidget__header .header__group .R-Button"
    ).trigger("click");
    $(".pdp-reviews_form").show();
    $('.desk_pdp-reviews-fill-popup').css('display', 'flex');
    $('body').addClass('popup-open');
    window.lockScroll();
  });

  $('.desk_pdp-reviews-popup-close').on('click', function () {
    closeReviewsPopup();
  });

  $('.desk_pdp-reviews-fill-popup').on('click', function (e) {
    if (!$(e.target).closest('.desk_pdp-reviews-fill-popup_content').length) {
      closeReviewsPopup();
    }
  });

  $(".pdp-reviews-form-submit__cancel").click(function () {
    $(
      ".reviews-pdp-section .reviews-pdp__blocks .overall-rating .button-block"
    ).show();
    $(".pdp-reviews_form").hide();
    $('.pdp-reviews_form-box').removeClass('error active valid');
    $('.pdp-reviews_stars_fillout').removeClass('error');
    $('.pdp-reviews__form').find('input').each(function(){
      $(this).val('');
    });
    $('.pdp-reviews__form').find('textarea').each(function(){
      $(this).val('');
    });
    $('.pdp-reviews-star-fill').removeClass('active');
  });

  $(".pdp-reviews-star-fill").mouseover(function () {
    var getData = $(this).attr("data");
    $(".pdp-reviews-star-fill").removeClass("hovered");
    if (getData == "1") {
      $(".pdp-reviews-star-fill[data='1']").addClass("hovered");
    } else if (getData == "2") {
      $(".pdp-reviews-star-fill[data='1']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='2']").addClass("hovered");
    } else if (getData == "3") {
      $(".pdp-reviews-star-fill[data='1']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='2']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='3']").addClass("hovered");
    } else if (getData == "4") {
      $(".pdp-reviews-star-fill[data='1']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='2']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='3']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='4']").addClass("hovered");
    } else if (getData == "5") {
      $(".pdp-reviews-star-fill[data='1']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='2']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='3']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='4']").addClass("hovered");
      $(".pdp-reviews-star-fill[data='5']").addClass("hovered");
    }
  });

  $(".pdp-reviews_stars_fillout").mouseleave(function () {
    $(".pdp-reviews-star-fill").removeClass("hovered");
  });

  $(".pdp-reviews-star-fill").click(function () {
    var getData = $(this).attr("data");
    $(".pdp-reviews-star-fill").removeClass("active");
    if (getData == "1") {
      $(".pdp-reviews-star-fill[data='1']").addClass("active");
    } else if (getData == "2") {
      $(".pdp-reviews-star-fill[data='1']").addClass("active");
      $(".pdp-reviews-star-fill[data='2']").addClass("active");
    } else if (getData == "3") {
      $(".pdp-reviews-star-fill[data='1']").addClass("active");
      $(".pdp-reviews-star-fill[data='2']").addClass("active");
      $(".pdp-reviews-star-fill[data='3']").addClass("active");
    } else if (getData == "4") {
      $(".pdp-reviews-star-fill[data='1']").addClass("active");
      $(".pdp-reviews-star-fill[data='2']").addClass("active");
      $(".pdp-reviews-star-fill[data='3']").addClass("active");
      $(".pdp-reviews-star-fill[data='4']").addClass("active");
    } else if (getData == "5") {
      $(".pdp-reviews-star-fill[data='1']").addClass("active");
      $(".pdp-reviews-star-fill[data='2']").addClass("active");
      $(".pdp-reviews-star-fill[data='3']").addClass("active");
      $(".pdp-reviews-star-fill[data='4']").addClass("active");
      $(".pdp-reviews-star-fill[data='5']").addClass("active");
    }
    clearError($(".pdp-reviews_stars_fillout"));
  });

  function boxHasValue($box) {
    return (
      $box.find("input, textarea").filter(function () {
        return $.trim($(this).val()) !== "";
      }).length > 0
    );
  }

  $(document).on("click", function (e) {
    var $clickedBox = $(e.target).closest(".pdp-reviews_form-box");
    if ($clickedBox.length) $clickedBox.addClass("active");
    $(".pdp-reviews_form-box")
      .not($clickedBox)
      .each(function () {
        var $box = $(this);
        if (!boxHasValue($box)) $box.removeClass("active");
      });
  });

  $(document).on(
    "focusin",
    ".pdp-reviews_form-box input, .pdp-reviews_form-box textarea",
    function () {
      var $box = $(this).closest(".pdp-reviews_form-box").addClass("active");
      $(".pdp-reviews_form-box")
        .not($box)
        .each(function () {
          var $b = $(this);
          if (!boxHasValue($b)) $b.removeClass("active");
        });
    }
  );

  function emailValid(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }
  function getRating() {
    return $(".pdp-reviews-star-fill.active").length || 0;
  }

  function setError($c) {
    var $box = $c.is(".pdp-reviews_form-box, .pdp-reviews_stars_fillout")
      ? $c
      : $c.closest(".pdp-reviews_form-box, .pdp-reviews_stars_fillout");
    $box.addClass("error");
  }

  function clearError($c) {
    var $box = $c.is(".pdp-reviews_form-box, .pdp-reviews_stars_fillout")
      ? $c
      : $c.closest(".pdp-reviews_form-box, .pdp-reviews_stars_fillout");
    $box.removeClass("error");
  }

  // Field validation mirroring the B2B contact form (sections/desk_b2b-form.liquid):
  // a field is invalid when empty, or — for the email field — when the value isn't a
  // valid email. Invalid → `.error` (desk-field shows its `.desk-field__msg`). This form
  // has NO green `.valid` success state — only the neutral/error states are used.
  var reviewFieldsSelector =
    ".pdp-reviews__form--textarea, .pdp-reviews__form--name, .pdp-reviews__form--email";

  function reviewFieldValid($field) {
    var val = $.trim($field.val() || "");
    // Required: star rating, name and email. Optional: the feedback message
    // (textarea) — an empty textarea is always valid. Required fields are invalid
    // when empty, and a filled-in email must also be a valid address.
    if ($field.hasClass("pdp-reviews__form--textarea")) return true;
    if (val === "") return false;
    if ($field.hasClass("pdp-reviews__form--email")) return emailValid(val);
    return true;
  }

  function validateReviewField($field) {
    var $box = $field.closest(".pdp-reviews_form-box");
    var ok = reviewFieldValid($field);
    $box.toggleClass("error", !ok);
    $box.removeClass("valid");
    return ok;
  }

  // Live re-validation as the user types (like the B2B form's `input` handler): the
  // error appears the moment a field is emptied / holds an invalid email, and clears
  // as soon as it becomes valid.
  $(document).on("input", reviewFieldsSelector, function () {
    validateReviewField($(this));
  });

  // Submit: validate every field + the star rating (mirrors B2B `validateAll`) and
  // block submission while anything is invalid.
  $(document).on("click", ".pdp-reviews-form-submit__submit", function () {
    var ok = true;

    if (getRating() < 1) {
      setError($(".pdp-reviews_stars_fillout"));
      ok = false;
    }

    $(reviewFieldsSelector).each(function () {
      if (!validateReviewField($(this))) ok = false;
    });

    if (!ok) return;

    fillReview({
      stars: getRating(),
      comment: $.trim($(".pdp-reviews__form--textarea").val() || ""),
      name: $.trim($(".pdp-reviews__form--name").val() || ""),
      email: $.trim($(".pdp-reviews__form--email").val() || ""),
      submit: true,
    });
  });

  function setNativeValue(el, value) {
    if (!el) return false;
    const proto = Object.getPrototypeOf(el);
    const descriptor = Object.getOwnPropertyDescriptor(proto, "value");
    if (descriptor && descriptor.set) descriptor.set.call(el, value);
    else el.value = value;
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
    el.blur();
    return true;
  }

  function fillReview({
    stars = 3,
    comment,
    name,
    email,
    submit = false,
  } = {}) {
    const starId =
      {
        1: "star-one",
        2: "star-two",
        3: "star-three",
        4: "star-four",
        5: "star-five",
      }[stars] || "star-three";

    $("#" + starId)
      .next("label")
      .trigger("click");

    const tryFill = () => {
      const ta = document.querySelector(
        'textarea[aria-labelledby="R-InputComments"]'
      );
      const nm = document.querySelector(
        'input[aria-labelledby="R-InputName"][type="text"]'
      );
      const em = document.querySelector(
        'input[aria-labelledby="R-InputEmail"][type="text"]'
      );

      const a = setNativeValue(
        ta,
        comment || "Loved it — does exactly what I needed."
      );
      const b = setNativeValue(nm, name || "Jane Tester");
      const c = setNativeValue(em, email || "jane.tester@example.com");

      if (a && b && c) {
        if (submit) $(".R-Button--submit").first().trigger("click");
        $(".pdp-reviews-form_status---after").css("display", "flex");
        $(".pdp-reviews-form_status---before").hide();
        console.log("Worked, submitted");
        return true;
      }
      return false;
    };

    if (!tryFill()) {
      let attempts = 0;
      const t = setInterval(function () {
        if (tryFill() || ++attempts >= 15) {
          clearInterval(t);
        }
      }, 120);
    }
  }


  $('.pdp-reviews-ai_summary_btn').click(function() {
      var mode = $(this).attr('data');
      var newText;
      if(mode == 'more'){
          newText = $(this).attr('data-full');
          $('.pdp-reviews-ai_summary_btn[data="more"]').hide();
          $('.pdp-reviews-ai_summary_btn[data="less"]').css('display', 'flex');
      }
      else{
          newText = $(this).attr('data-truncated');
          $('.pdp-reviews-ai_summary_btn[data="more"]').css('display', 'flex');
          $('.pdp-reviews-ai_summary_btn[data="less"]').hide();
      }
      $(this).closest('.pdp-reviews-ai-summary-box').find('.pdp-reviews-ai-summary_text').html(newText);
  });

  setInterval(function(){
    loadReviewData();
  },1000);
  
  function loadReviewData(){
    // Add badge icon
    $('.cssVar-badgeElement__text').each(function(){
      if (!$(this).find('img[alt="badge icon"]').length) {
        $(this).append('<img src="https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Group_505548.png?v=1757337931" alt="badge icon">');
      }
    });
  
    // Replace "Yes" with icon + count
    $('.item__inner .R-TextBody.R-TextBody--xxxs.R-TextBody--inline.u-marginBottom--none.u-marginRight--sm.u-cursorPointer.u-textDecoration--underline').each(function(){
      const $btn = $(this);
  
      if (!$btn.find('.pdp-reviews_like-icon').length) {
        $btn.addClass('reviewLike-btn')
            .html('<img class="pdp-reviews_like-icon" src="https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Icon_2_d7f6aeb9-0636-45d8-b370-1899b26f3637.png?v=1757407762" alt="helpful button">');
      }
  
      let count = 0;
      const $helpText = $btn.closest('.R-ContentList__item').find('em.R-TextBody').first();
      if ($helpText.length) {
        const m = ($helpText.text() || '').match(/[\d.,]+/);
        if (m) count = parseInt(m[0].replace(/[^\d]/g, ''), 10) || 0;
      }
  
      if (!$btn.find('.pdp-reviews_like-count').length) {
        $btn.append(`<span class="pdp-reviews_like-count">${count}</span>`);
      } else {
        $btn.find('.pdp-reviews_like-count').text(count);
      }
    });
  
   // Get active sort item text
    loadSortLabel();
  }

  function loadSortLabel(){
    const $firstActive = $('.R-DropUpDownMenu__item.isActive').first();
    const activeSortText = $firstActive.find('.R-TextBody').text().trim();

    if (activeSortText) {
      const $arrowSpan = $('.reviews-pdp-section .reviews-pdp__blocks .real-reviews .ElementsWidget-prefix .R-TabControls .R-TabControls__item>.R-TextHeading .ricon-thin-arrow--down');
      
      // Ensure we don’t duplicate text
      if (!$arrowSpan.find('.active-sort-label').length) {
        $arrowSpan.append(` <span class="active-sort-label">${activeSortText}</span>`);
      } else {
        $arrowSpan.find('.active-sort-label').text(activeSortText);
      }
    }
  }
  

  $('.R-DropUpDownMenu__item').click(function(){
    setTimeout(function(){
      loadSortLabel();
    },200);
  });
  

  $('.product__rating-wrapper a, .pdp_rating-tooltip').on('mouseenter', function() {
    if ($(window).width() > 960) {
      $('.pdp_rating-tooltip').show();
    }
  });
  
  $('.product__rating-wrapper a, .pdp_rating-tooltip').on('mouseleave', function() {
    if ($(window).width() > 960) {
      setTimeout(function() {
        if (
          !$('.product__rating-wrapper a:hover').length &&
          !$('.pdp_rating-tooltip:hover').length
        ) {
          $('.pdp_rating-tooltip').hide();
        }
      }, 100);
    }
  });
  

  $('.product__rating-wrapper').find('a').click(function(e){
    e.preventDefault();
    if ($(window).width() < 768) {
      $('html, body').animate({
          scrollTop: $(".reviews-summary_outer").offset().top-50
      }, 500);  
    }
    else{
      $('.pdp_rating-tooltip').show();
    }
    
  });

  $('.pdp_rating-tooltip-close').click(function(){
    $('.pdp_rating-tooltip').hide();
  });

  $(document).on('keydown', function(e){
    if (e.key === 'Escape') {
      $('.pdp_rating-tooltip').hide();
      closeReviewsPopup();
    }
  });

  $(document).on('mousedown touchstart', function(e) {
    const $tooltip = $('.pdp_rating-tooltip:visible');
    if (!$tooltip.length) return;
  
    const clickedInsideTooltip = $(e.target).closest('.pdp_rating-tooltip-inner').length > 0;
    const clickedOpener = $(e.target).closest('.product__rating-wrapper').length > 0;
  
    if (!clickedInsideTooltip && !clickedOpener) {
      $tooltip.hide();
    }
  });

  $('.pdp-tooltip_scrolldown').click(function(){
    $('.pdp_rating-tooltip').hide();
    $('html, body').animate({
        scrollTop: $(".reviews-pdp").offset().top
    }, 500);
  });

  


  $('.rsp_popup-close').on('click', function(){
    $('.rsp_popup-outer').hide();
    $('.rsp_popup-review-info').removeClass('loaded');
    window.unlockScroll();
  });

  $(document).on('mousedown touchstart', function (e) {
    const $open = $('.rsp_popup-outer:visible');
    if (!$open.length) return;

    const clickedInside = $(e.target).closest('.rsp_popup-inner').length > 0;
    if (!clickedInside) {
      $open.hide();
      window.unlockScroll();
    }
    $('.rsp_popup-review-info').removeClass('loaded');
  });

  $(document).on('mousedown touchstart', '.rsp_popup-inner', function (e) {
    e.stopPropagation();
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      $('.rsp_popup-outer:visible').hide();
      $('.rsp_popup-review-info').removeClass('loaded');
      window.unlockScroll();
    }
  });
  

  const $gallery  = $('.rsp_popup-thumbnails_gallery--outer');
  const $btnRight = $('.rsp_popup-thumbs-arrow__right');
  const $btnLeft  = $('.rsp_popup-thumbs-arrow__left');
  const step = 200;

  function updateArrows() {
    if (!$gallery.length || !$gallery[0]) return;

    const maxScroll  = $gallery[0].scrollWidth - $gallery.outerWidth();
    const scrollLeft = $gallery.scrollLeft();

    if (maxScroll <= 0) {
      $btnLeft.addClass('disabledArrow');
      $btnRight.addClass('disabledArrow');
      return;
    }

    $btnLeft.toggleClass('disabledArrow',  scrollLeft <= 0);
    $btnRight.toggleClass('disabledArrow', scrollLeft >= maxScroll - 1);
  }

  function initArrowStateWhenVisible() {
    // wait until the element is actually measurable
    const ready = () =>
      $gallery.is(':visible') &&
      $gallery.outerWidth() > 0 &&
      $gallery[0].scrollWidth > 0;

    if (ready()) {
      // nudge scroll to trigger layout/scroll handlers reliably
      const s = $gallery.scrollLeft();
      $gallery.scrollLeft(s + 1);
      $gallery.scrollLeft(s);
      updateArrows();
      return;
    }

    // retry until visible/measurable
    let tries = 0;
    const t = setInterval(() => {
      if (ready() || ++tries > 40) { // ~2s
        clearInterval(t);
        if (ready()) {
          const s = $gallery.scrollLeft();
          $gallery.scrollLeft(s + 1);
          $gallery.scrollLeft(s);
          updateArrows();
        }
      }
    }, 50);
  }

  // click handlers (you already had these)
  $btnRight.on('click', function () {
    if ($btnRight.hasClass('disabledArrow')) return;
    $gallery.animate({ scrollLeft: $gallery.scrollLeft() + step }, 200, updateArrows);
  });

  $btnLeft.on('click', function () {
    if ($btnLeft.hasClass('disabledArrow')) return;
    $gallery.animate({ scrollLeft: $gallery.scrollLeft() - step }, 200, updateArrows);
  });


  function updateArrows() {
    if (!$gallery.length || !$gallery[0]) return;
    const maxScroll  = $gallery[0].scrollWidth - $gallery.outerWidth();
    const scrollLeft = $gallery.scrollLeft();
  
    if (maxScroll <= 0) {
      $btnLeft.addClass('disabledArrow');
      $btnRight.addClass('disabledArrow');
      return;
    }
    $btnLeft.toggleClass('disabledArrow',  scrollLeft <= 0);
    $btnRight.toggleClass('disabledArrow', scrollLeft >= maxScroll - 1);
  }
  
  // 👉 add this: rAF-throttled scroll + scrollend debounce
  let ticking = false;
  let scrollEndTimer = null;
  
  $gallery.on('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(() => { ticking = false; updateArrows(); });
    }
    clearTimeout(scrollEndTimer);
    scrollEndTimer = setTimeout(updateArrows, 120); // fires after momentum stops
  });
  
  // Also run after drag ends (covers touch/trackpads)
  $gallery.on('touchend pointerup mouseup', function () {
    setTimeout(updateArrows, 0);
    setTimeout(updateArrows, 150); // one more after inertia
  });

  $gallery.on('scroll', updateArrows);

  // Recompute when popup opens (call this where you show it)
  function openPopup() {
    $('.rsp_popup-outer').css('display', 'flex');
    initArrowStateWhenVisible();
    // if you have a CSS transition for opening, run once more after it ends:
    setTimeout(updateArrows, 250);
  }

  // Also cover image loads and window resize
  $(window).on('load resize', initArrowStateWhenVisible);
  $gallery.find('img').each(function(){
    if (this.complete) return;
    $(this).one('load', initArrowStateWhenVisible);
  });

  // Initial attempt (in case it’s already visible)
  requestAnimationFrame(initArrowStateWhenVisible);




  $(function () {
    const $thumbWrap = $('.rsp_popup-thumbnails_gallery');
    const $outer     = $('.rsp_popup-thumbnails_gallery--outer'); // scrollable strip
    const $popup     = $('.rsp_popup-outer');
    const big = s => (s || '').replace(/height=\d+&width=\d+/i, 'height=900&width=900');

    var currentThumbnailEl = null;

    function setMainImageProgressive(thumbSrc, largeSrc) {
      var $img = $('.rsp_popup-main-image__src');
      if (thumbSrc) $img.attr('src', thumbSrc);
      $img.addClass('loadingImage');
      var hi = new Image();
      hi.onload = function () { $img.attr('src', largeSrc).removeClass('loadingImage'); };
      hi.src = largeSrc;
    }

    function loadPopupData(){
      setTimeout(function(){
        $('.rsp_popup-name').html($('#R-TextHeading-modal').html() || '');
        $('.rsp_popup-days').html($('.R-GlobalModal .R-TextHeading.R-TextHeading--xxxxs > span > div').html() || '');
        var revContent = $('.R-GlobalModal .R-TextBody.R-TextBody--xxs').html() || '';
        $('.rsp-popup_review_content').html('<p>' + revContent + '</p>');
        $('.rsp-popup_stars').html($('.R-GlobalModal .R-RatingStars__stars').html() || '');
        $('.rsp-popup_helpful-btn').removeClass('liked');
        $('.rsp_popup-review-info').addClass('loaded');
      }, 200);
    }
  
    function buildThumbs(goToLast) {
      const $items = $('.R-MediaSlider__item--reviewPhoto');
      if (!$items.length) return false;

      $thumbWrap.empty();
      $items.each(function(i){
        const src = $(this).find('img.image__src').attr('src') || '';
        $(this).attr('data-origin-index', i);
        $thumbWrap.append(
          `<div class="rsp_popup-thumb${(i===0 && !goToLast)?' active':''}" data-index="${i}" data-large="${big(src)}">
             <img loading="lazy" src="${src}">
           </div>`
        );
      });

      const $activeThumb = goToLast
        ? $thumbWrap.find('.rsp_popup-thumb').last().addClass('active')
        : $thumbWrap.find('.rsp_popup-thumb').first();
      if ($activeThumb.length) setMainImageProgressive($activeThumb.find('img').attr('src'), $activeThumb.attr('data-large') || $activeThumb.find('img').attr('src'));

      updateArrows();
      return true;
    }
  
    function activeIndex(){
      return Number($thumbWrap.find('.rsp_popup-thumb.active').data('index'));
    }
    function count(){ return $thumbWrap.find('.rsp_popup-thumb').length; }
    function lastIndex(){ return count() - 1; }
  
    function ensureInView($t){
      if (!$outer.length || !$t.length) return;
      const viewLeft  = $outer.scrollLeft();
      const viewRight = viewLeft + $outer.innerWidth();
      const left  = $t.position().left + viewLeft;
      const right = left + $t.outerWidth();
      let target = viewLeft;
      if (left < viewLeft) target = left - 8;
      else if (right > viewRight) target = right - $outer.innerWidth() + 8;
      if (target !== viewLeft) $outer.animate({ scrollLeft: target }, 200);
    }
  
    function getAllGalleryThumbnails() {
      return $('.R-PhotoVideoThumbnail');
    }

    function getCurrentThumbnailIndex() {
      if (!currentThumbnailEl) return -1;
      var idx = -1;
      getAllGalleryThumbnails().each(function(i) {
        if (this === currentThumbnailEl) { idx = i; return false; }
      });
      return idx;
    }

    function navigateToReview(dir) {
      var allThumbs = getAllGalleryThumbnails();
      var targetIdx = getCurrentThumbnailIndex() + dir;
      if (targetIdx < 0 || targetIdx >= allThumbs.length) return;

      var $targetThumb = allThumbs.eq(targetIdx);
      var goToLast = (dir < 0);
      currentThumbnailEl = $targetThumb[0];
      $targetThumb.trigger('click');

      setTimeout(function() {
        if (buildThumbs(goToLast)) updateArrows();
      }, 300);
    }

    function updateArrows(){
      if ($('.rsp_popup-outer').attr('data-supa-source')) return;
      var i = activeIndex();
      var allThumbs = getAllGalleryThumbnails();
      var thumbIdx = getCurrentThumbnailIndex();

      var leftDisabled  = (i <= 0)          && (thumbIdx <= 0);
      var rightDisabled = (i >= lastIndex()) && (thumbIdx < 0 || thumbIdx >= allThumbs.length - 1);

      $('.rsp_popup-media-arrow__left').toggleClass('disabledArrowMain', leftDisabled);
      $('.rsp_popup-media-arrow__right').toggleClass('disabledArrowMain', rightDisabled);
    }

    function goTo(i){
      if (i < 0 || i > lastIndex()) return;
      $('.rsp_popup-main-image__src').addClass('loadingImage');
      const $orig = $(`.R-MediaSlider__item--reviewPhoto[data-origin-index="${i}"]`);
      if ($orig.length) $orig.trigger('click'); // this will also open/sync and load data
      const $t = $thumbWrap.find(`.rsp_popup-thumb[data-index="${i}"]`);
      ensureInView($t);
      setTimeout(updateArrows, 0);
    }
  
    // Delegate: original slider item click -> open popup & sync
    $(document).on('click', '.R-MediaSlider__item--reviewPhoto', function(){
      const i = Number($(this).attr('data-origin-index') ?? $(this).index());
      $('.rsp_popup-main-image__src').addClass('loadingImage');
      $thumbWrap.find('.rsp_popup-thumb').removeClass('active');
      const $activeThumb = $thumbWrap.find(`.rsp_popup-thumb[data-index="${i}"]`).addClass('active');
      const large = $activeThumb.attr('data-large');
      const thumbSrc = $activeThumb.find('img').attr('src');
      if (large) setMainImageProgressive(thumbSrc, large);

      $popup.css('display', 'flex');

      loadPopupData();
      updateArrows();
    });

    $(document).on('click', '.R-PhotoVideoThumbnail', function(){
      currentThumbnailEl = this;
      const i = Number($(this).attr('data-origin-index') ?? $(this).index());
      $thumbWrap.find('.rsp_popup-thumb').removeClass('active');
      const $activeThumb = $thumbWrap.find(`.rsp_popup-thumb[data-index="${i}"]`).addClass('active');
      const large = $activeThumb.attr('data-large');
      const currentImg = $(this).find('.R-PhotoVideoThumbnail__image').attr('src');

      $popup.css('display', 'flex');

      loadPopupData();
      updateArrows();
      setMainImageProgressive(currentImg, large || currentImg);
    });

    
  
    // New thumb click -> trigger original
    $(document).on('click', '.rsp_popup-thumb', function(){
      const i = $(this).data('index');
      goTo(i);
    });
  
    // Arrow clicks -> navigate within media (reviews.io widget popup only)
    $(document).on('click', '.rsp_popup-media-arrow__right', function(){
      if ($('.rsp_popup-outer').attr('data-supa-source')) return;
      if ($(this).hasClass('disabledArrowMain')) return;
      var i = activeIndex();
      if (i >= lastIndex()) {
        navigateToReview(1);
      } else {
        goTo(i + 1);
      }
    });
    $(document).on('click', '.rsp_popup-media-arrow__left', function(){
      if ($('.rsp_popup-outer').attr('data-supa-source')) return;
      if ($(this).hasClass('disabledArrowMain')) return;
      var i = activeIndex();
      if (i <= 0) {
        navigateToReview(-1);
      } else {
        goTo(i - 1);
      }
    });
  
    // Keep arrows updated if user scrolls thumb strip manually
    $outer.on('scroll', updateArrows);
  
    // Build thumbs now or when slider appears
    if (!buildThumbs()) {
      const obs = new MutationObserver(() => {
        if (buildThumbs()) obs.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  });
  

  $(document).on('click', '.rsp-popup_helpful-btn', function () {
    const $btn = $(this);
  
    if ($btn.hasClass('liked')) {
      $btn.removeClass('liked');
     
    } else {
      $btn.addClass('liked');
  
    }
  });


  $(document).on("click",".reviewLike-btn",function() {
    console.log('CLicked');
    $(this).find('.pdp-reviews_like-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Asset_2.png?v=1757504998');
    var currentCount = parseFloat($(this).find('span').html());
    currentCount++;
    $(this).find('span').html(currentCount);
  });

  $(document).on("click",".R-PaginationControls__item *",function() {
    console.log('clicked ');
    loadReviewData();
  });
  
  
  
  // function duplicateElements() {
  //   const $newWrap = $('.filter__rsp-tab-content[data="sorting"]');
  //   const $orderGroup = $('.R-DropUpDownMenu__inner .c-filters__dropdown__group').first();
  //   const $oldItems = $orderGroup.find('.R-DropUpDownMenu__item[role="button"]');
  
  //   const $tpl = $('<div class="filter__rsp-tab-sort-line">' +
  //                    '<div><div class="filter__sorting-bubble"><div class="filter__sorting-bubble-inner"></div></div></div>' +
  //                    '<div><p></p></div>' +
  //                  '</div>');
  
  //   $newWrap.empty();
  //   $oldItems.each(function(i){
  //     const $old = $(this);
  //     const label = $.trim($old.find('.R-flex-row > div').first().text());
  //     const active = $old.hasClass('isActive');
  
  //     const $row = $tpl.clone().attr('data-index', i);
  //     $row.find('p').text(label);
  //     if (active) $row.addClass('active');
  
  //     $newWrap.append($row);
  //     $old.attr('data-order-index', i);
  //   });
  
  //   $(document).on('click', '.filter__rsp-tab-content[data="sorting"] .filter__rsp-tab-sort-line', function(){
  //     const i = $(this).data('index');
  //     $(this).addClass('active').siblings('.filter__rsp-tab-sort-line').removeClass('active');
  //     const $orig = $oldItems.eq(i);
  //     if ($orig.length) $orig.trigger('click');
  //   });
  
  //   $oldItems.on('click', function(){
  //     const i = $(this).attr('data-order-index');
  //     const $row = $newWrap.find('.filter__rsp-tab-sort-line[data-index="'+i+'"]');
  //     $row.addClass('active').siblings('.filter__rsp-tab-sort-line').removeClass('active');
  //   });
  // }
  

  
  
  function insertMobileTrigger() {
    var title = $('.reviews-pdp-dynamic-copies').data('mobile-filter-btn-title') || 'Filtern & Sortieren';
  
    var html = '<div class="reviews-pdp_mobile_filter_trigger__outer"><div class="reviews-pdp_mobile_filter_trigger">'
      + '<div><img src="https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Group_e1c866a0-be67-4a65-bcff-9f5a7d16f2c9.png?v=1757576507"></div>'
      + '<div><p>' + title + '</p></div>'
      + '<div class="reviews-pdp_mobile_filter__active-count"><span>2</span></div>'
      + '</div></div>';
  
    function tryInsert() {
      var $panel = $('#product-review-panel');
      if ($panel.length && !$('.reviews-pdp_mobile_filter_trigger').length) {
        $panel.before(html);
        return true;
      }
      return false;
    }
  
    if (tryInsert()) return;
  
    var mo = new MutationObserver(function () {
      if (tryInsert()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  
  insertMobileTrigger();
  

  function syncDisabledFilters() {
    $('.R-DropUpDownMenu__item.isDisabled').each(function () {
      const label = $(this).find('.R-RatingStars__stars[aria-label]').attr('aria-label') || '';
      const m = label.match(/(\d+)/); // "5 star rating" -> "5"
      if (m) {
        const star = m[1];
        $(".overall-rating_filter_line[data='" + star + "']").addClass('isDisabled');
        $(".mob-overall-rating_filter_line[data='" + star + "']").addClass('isDisabled');
        $(".star.star_filter-line-top[data='" + star + "']").addClass('isDisabled');
      }
    });
  }
  
  setTimeout(syncDisabledFilters, 1000);
  

  $(document).on('click', function(e) {
    if (
      $(e.target).closest(
        '.R-DropUpDownMenu.R-DropUpDownMenu--md.R-DropUpDownMenu--maxHeight380.u-paddingBottom--none.js-demo-sortdropdown.isActive'
      ).length === 0
    ) {
      $('.R-DropUpDownMenu.js-demo-sortdropdown').removeClass('isActive');
      $('.R-DropUpDownMenu.js-demo-sortdropdown').addClass('u-hidden--all');
      $('.c-filters__triggerButton').attr('aria-expanded', false);
    }
  });


  $('.c-filters__triggerButton').click(function(e){
    e.preventDefault();
    $('.R-DropUpDownMenu.js-demo-sortdropdown').addClass('isActive');
    $('.R-DropUpDownMenu.js-demo-sortdropdown').removeClass('u-hidden--all');
    $('.c-filters__triggerButton').attr('aria-expanded', true);
  });
  
  

});
